import { inject, Injectable } from '@angular/core';
import { DATEPICKER_TRANSLATION_CONFIG } from '../tokens/datepicker-translation-config.token';
import { DEFAULT_DATEPICKER_TRANSLATIONS } from '../constants/datepicker-translations.const';

@Injectable({
	providedIn: 'root',
})
export class DatepickerTranslationService {
	private config = inject(DATEPICKER_TRANSLATION_CONFIG, { optional: true });

	translate(key: string, params?: any): string {
		// If a custom translateFn is provided, use it
		if (this.config?.translateFn) {
			return this.config.translateFn(key, params);
		}

		// Otherwise use the provided translations or defaults
		const translations = this.config?.translations || DEFAULT_DATEPICKER_TRANSLATIONS;
		let translation = translations[key] || key;

		// Handle parameter substitution for translations like "Week {week}"
		if (params && typeof translation === 'string') {
			Object.keys(params).forEach((param) => {
				translation = translation.replace(`{${param}}`, params[param]);
			});
		}

		return translation;
	}
}
